import type { Utility } from '../../../types/utility';
import type { LogoSection } from './index';

const basecolors: Utility.VariantCSSKeys<LogoSection.Color.VariantKeys> = {
  original: {},
  white: {
    filter: 'grayscale(100%) brightness(0%) invert(100%)',
  },
  dark: {
    filter: 'grayscale(100%) contrast(0%) brightness(35%)',
  },
  grayscale: {
    filter: 'contrast(60%) grayscale(100%)',
  },
  coolGrey: {
    filter: 'contrast(0%) sepia(100%) brightness(85%) hue-rotate(180deg) saturate(20%) brightness(128%)',
  },
  coolGrey70: {
    filter: 'contrast(0%) sepia(100%) brightness(85%) hue-rotate(180deg) saturate(50%) brightness(90%)',
  },
};

const colors: Utility.VariantKeyModes<LogoSection.Color.VariantKeys> = {
  products: {
    chart: basecolors,
    chartblog: basecolors,
    co: basecolors,
    edu: basecolors,
    scale: basecolors,
    spark: basecolors,
  },
};

export const colorVariants = Object.keys(basecolors) as LogoSection.Color.VariantKeys[];

export default colors;
